<template>
    <a-modal
      title="Are you sure you want to delete this visitor ?"
      :visible="visible"
      :closable="false"
      okText="Yes"
      cancelText="No"
      :confirm-loading="isLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      
        <span style="font-weight: 600;" class="text-danger">
            Warning: All appointments of this visitor will be deleted as well
        </span>
        
    </a-modal>
</template>
<script>

import { useAppointmentsStore } from '../../../../stores/appointments-store';
import { mapActions, mapState } from 'pinia';
import { toastMixin } from '../../../../mixins/ToastMixin';
import { visitorsClient } from '../../../../api/config';


export default {
    components: {
        
    },
    mixins: [ toastMixin ],
    data() {
        return {
            item: null,
            isLoading: false,
            visible: false,
        }
    },
    computed: {
        // ...mapState(useAppointmentsStore, { 'item': 'selectedAppointment' }),
        // type() {
        //     if (this.item && this.item.type)
        //         return this.item.type;
        //     return '';
        // }
    },
    methods: {
        // ...mapActions(useAppointmentsStore, [ 'approveSelectedAppointment' ]),
        handleOk() {
            // this.approveSelectedAppointment(this.hour, this.min, this.date, Number(this.duration));
            // this.visible = false;
            this.isLoading = true;
            visitorsClient.deleteVisitor(this.item.id).then(res => {
                if (!res.networkError) {
                    if (res.status == 202) {
                        this.successToast(this.$t('toast-success-messages.delete-visitor'));
                        this.visible = false;
                    } else {
                        this.errorToast(this.$t('toast-error-messages.delete-visitor'));
                    }
                } else {
                    this.errorToast(this.$t('toast-error-messages.network-error'));
                }
                this.isLoading = false;
            })
            // let data = { id: this.item.id, hour: this.hour, min: this.min, date: this.date, durationInMins: Number(this.duration) };
            // appointmentsClient.approveAppoinment(data).then(res => {
            //     if (!res.networkError) {
            //         if (res.status == 202) {
            //             this.approveSelectedAppointment(this.hour, this.min, this.date, Number(this.duration));
            //             this.visible = false;
            //             this.successToast('Successfully approved Appointment');    
            //             this.$emit('success', this.item.id);
            //         } else {
            //             this.errorToast('Error approving Appointment, status code :: ' + res.status);    
            //         }
            //     } else {
            //         this.errorToast('Network Error, Could not approve Appointment, please check network connection');    
            //     }
                
            //     this.isLoading = false;
            // });
        },
        handleCancel() {
            this.visible = false;
        },
        showModal(item) {
            this.item = item;
            this.visible = true;
        },
    }
    
}
</script>